import React, { useContext, useMemo } from "react";
import styles from "@/page-components/snapshot/snapshots.module.css";
import clsx from "clsx";
import style from "@/page-components/RightSizing/rightSizing.module.css";
import styleMain from "@/page-components/ri-utilization/utilization.module.css";
import {
  formatCount,
  ToolTipComponent,
} from "@/page-components/cost-explorer/components/cost-explorer-header.component";
import { AnomalyContext } from "@/page-components/Cost-Anomaly/cost-anomaly.context";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import HeaderState from "@/components/States/HeaderState";
import anomalyStyle from "@/page-components/Cost-Anomaly/anomaly.module.css";
import {
  useCostStats,
  useCountStats,
  useMaxStats,
} from "@/services/cost-anomaly/get-all-cloud-header-apis.repo";
import config from "@/config";

const AllCloudAnomalyHeader = ({ service }) => {
  const context = useContext(AnomalyContext);

  const query = useMemo(() => {
    return {
      service: service,
    };
  }, []);
  const {
    data: costData,
    isLoading: costLoading,
    error: costError,
  } = useCostStats(query);
  const {
    data: maxData,
    isLoading: maxLoading,
    error: maxError,
  } = useMaxStats(query);
  const {
    data: countData,
    isLoading: countLoaing,
    error: countError,
  } = useCountStats(query);

  const formattedTotalSpend = formatCount(costData?.totalCost || 0);
  const formattedTotalAnomalyCost = formatCount(
    costData?.totalAnomalyCost || 0
  );
  const formattedMaxCost = formatCount(maxData?.maxCost || 0);

  const enabledClouds = config.enabledClouds;

  const cloudMapping = [
    { key: "aws", label: "AWS", percentage: countData?.awsPercentage ?? 0 },
    {
      key: "azure",
      label: "Azure",
      percentage: countData?.azurePercentage ?? 0,
    },
    { key: "gcp", label: "GCP", percentage: countData?.gcpPercentage ?? 0 },
  ];

  // Filter only enabled clouds
  const filteredClouds = cloudMapping.filter((cloud) =>
    enabledClouds.has(cloud.key)
  );

  // Sort by percentage (highest first)
  const sortedClouds = [...filteredClouds].sort(
    (a, b) => b.percentage - a.percentage
  );

  // Highest spike cloud
  const topCloud = sortedClouds[0];
  // Remaining
  const otherClouds = sortedClouds.slice(1);

  return (
    <div
      className={
        (!(costLoading && countLoaing && maxLoading) &&
          maxData &&
          costData &&
          countData) ||
        (countError && maxError && costError)
          ? "container-fluid main-container Inner_main_container"
          : ""
      }
      style={{ padding: "16px 40px" }}
    >
      {((!(costLoading && countLoaing && maxLoading) &&
        maxData &&
        costData &&
        countData) ||
        (countError && maxError && costError)) && (
        <div className={styles.inner_first_container}>
          <span className={styles.inner_first_container_text}>
            Cost Anomalies
          </span>
        </div>
      )}
      {countError && maxError && costError && (
        <ScenariosErrorState
          // error={`${countError?.message} | ${maxError?.message} | ${costError?.message}`}
          error={countError?.message}
          headerItem="header"
          messageConfig={{}}
        />
      )}
      {costLoading && countLoaing && maxLoading && <HeaderState />}
      {maxData && costData && countData && (
        <div className={clsx("row", styles.snap_sec_div)}>
          <div
            className={clsx(styles.snapshots_main, styleMain.containerPadding)}
            style={{ width: "25%" }}
          >
            <span className={styles.snapshot_text}>
              Total Anomalies detected
            </span>
            <span className={styles.snapshot_value}>
              <span style={{ cursor: "context-menu" }}>
                {countData?.total || 0}
              </span>
            </span>
            <span className={anomalyStyle.lasts_day_count}>
              In Last 90 Days
            </span>
          </div>

          <div
            className={clsx(styles.snapshots_main, styleMain.containerPadding)}
            style={{
              width: "50%",
              background: "#F8F9FA",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className={styles.snapshot_text}>Highest Cost Spike</span>
              <span className={styles.snapshot_value}>
                {/* {maxData?.maxCost || 0} */}

                <ToolTipComponent data={maxData?.maxCost || 0}>
                  <span style={{ cursor: "context-menu" }}>
                    {formattedMaxCost}
                  </span>
                </ToolTipComponent>
              </span>
              <span className={anomalyStyle.higest_cost_percentage}>
                on {maxData?.filterValue || "--"} ({maxData?.costDate || "--"})
              </span>
            </div>

            <div style={{ width: "50%" }}>
              <span className={styles.snapshot_text}>Most impacted cloud</span>
              {topCloud && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <span className={styles.snapshot_value}>
                    {topCloud.label || "--"}
                  </span>
                  <div className={anomalyStyle.anomaly_percentage}>
                    {topCloud.percentage?.toFixed(2) || "0"}% of anomalies
                  </div>
                </div>
              )}
              {otherClouds.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "8px",
                  }}
                  className={anomalyStyle.cloud_anomaly}
                >
                  {otherClouds.map((cloud) => (
                    <span key={cloud.key}>
                      {cloud.label || "--"}:{" "}
                      {cloud.percentage?.toFixed(2) || "0"}%
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div
            className={clsx(style.rec_second_div_third_container)}
            style={{ width: "25%", background: "#056EE5", gap: "0px" }}
          >
            <div className="container-fluid innerContainer-1">
              <div className="container innerContainer-div">
                <div className="container innerContainer-text">
                  <div className="container innerContainer-text-1">
                    Total Anomalies Cost
                  </div>
                  <div
                    className="container innerContainer-text-2"
                    style={{ display: "flex", gap: "4px" }}
                  >
                    <ToolTipComponent data={costData?.totalAnomalyCost || 0}>
                      <span style={{ cursor: "context-menu" }}>
                        {formattedTotalAnomalyCost}
                      </span>
                    </ToolTipComponent>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={clsx("container-fluid", anomalyStyle.innerContainer_2)}
            >
              <div
                className={clsx(
                  "container",
                  anomalyStyle.innerSecondContainer_text
                )}
              >
                Total Spend (All Clouds)
              </div>
              <div
                className={clsx(
                  "container",
                  anomalyStyle.innerSecondContainer_num
                )}
              >
                <ToolTipComponent data={costData?.totalCost || 0}>
                  {formattedTotalSpend}
                </ToolTipComponent>
              </div>
            </div>
          </div>
        </div>
      )}

      {((!(costLoading && countLoaing && maxLoading) &&
        maxData &&
        costData &&
        countData) ||
        (countError && maxError && costError)) && (
        <div
          className={clsx("contnainer-fluid ", styles.inner_third_container)}
        >
          <div className={clsx("container-fluid", styles.inner_contaier_text)}>
            Updated Today at 7:05AM
          </div>
        </div>
      )}
    </div>
  );
};

export default AllCloudAnomalyHeader;
